//@flow
import {
  GET_CAMPAIGN_RESOURCES_REQUESTING,
  VISIT_CAMPAIGN_RESOURCE_REQUESTING,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING,
} from "./constants";

export const getCampaignResourcesRequest = (payload: {
  campaignId: string;
  userId: string;
}) => {
  return {
    type: GET_CAMPAIGN_RESOURCES_REQUESTING,
    payload,
  };
};

// attention, dans la DB, il faut un coachingSessionId, car c'est une fonction qui est également appelé dans le coaching saga.
// dans le controller resource => fonction visit => il y a un if(coachingSessionId)
export const visitResourceRequest = (payload: {
  resourceId: string;
  campaignId: string;
  userId: string;
  userCampaignId: string;
}) => {
  return {
    type: VISIT_CAMPAIGN_RESOURCE_REQUESTING,
    payload,
  };
};

// utilisé ?
// dans le controller campaignId et userId mais la fonction n'est appelé nul part ^^
export const sendResourceFeedbackRequest = payload => {
  return {
    type: SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING,
    payload,
  };
};
